<template>
<span>
        <span v-show="enabled">
            <div  class="multiselect"></div>
        </span>
        <span v-show="!enabled">
            <div  class="multiselect" disabled="disabled"></div>
        </span>
    </span>
</template>

<script>

export default {
    name: 'LayuiMultiSelect',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-multiselect-' + window.uuid();
            },
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        clickClose: {
           type: Boolean,
            default: ()=>{
                return true;
            } 
        },
         //是否严格遵守父子模式
        strict: {
            type: Boolean,
            default: ()=>{
                return false;
            }
        },
        lazy : {
            type: Boolean,
            default: ()=> {
                return false;
            }
        },
        _model: {
            default: null,
            required: false
        },
        initValue: {
            required: false,
            type: String
        },
        initData: {
            type: Array,
            default: () => {
                return []
            }
        },
        autoRow: {
            type: Boolean,
            default: true
        },
        textField: {
            default: "text",
            type: String
        },
        valueField: {
            default: "value",
            type: String
        },
        idField: {
            default: '',
            type: String
        },
        parentField: {
            default: '',
            type: String
        },
        enableSearch: {
            default: false,
            type: Boolean
        },
        // 配置了 tableName 那么slot插槽就不起作用
        tableName: {
            type: String,
            default: ''
        },
        queryCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        selectFields: {
            type: String,
            default: '',
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        cacheCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        single: {
            type: Boolean,
            default: false
        },
        renderText: {
            type: Function,
            default: (row, textField)=> {
                return row[textField];
            }
        },
        renderLabel: {
            type: Function,
            default: (row, textField)=> {
                return row[textField];
            }
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data () {
        return {
            id : null,
            el : null,
            isloaded: false,
            selectData: null, //当前选中的值
            condition: {},
            data: [],
            showPage: false,
        }
    },
    methods: {
        getData() {
            return this.data;
        },
        getDataByValue(value) {
            return this.data.find((obj)=>{
                if(obj.value == value) {
                    return obj;
                }
            });
        },
        getSelectData() {
            return this.selectData;
        },
        setData(data) {
            this.data = data;
            this.load();
        },
        clearValue(){
             this.$emit('_modelEvent', '');
        },
        selectValue(selectData) {
            //插件要求是数组格式
           selectData = selectData ? '' + selectData : '';
           this.xmSelect.setValue(selectData.split(","));
        },
        handleShowPage(data){
          this.showPage = false
          if(data.length >= 50){
            this.showPage = true
          }
        },

        // 根据最新的data,刷新select
        load() {
            var that = this;
            this.select.children().remove();
            if(!this.data) {
                this.data = [];
            }
            var transferData = [];
            this.data.forEach((e)=>{
                transferData.push(
                    {name: e[this.textField], label: that.renderLabel(e, that.textField), value: e[this.valueField], _row: e, _treeId: e[this.idField], _treePid: e[this.parentField]}
                );
            });
            if(this.showTree){
                this.map = {};
                var rootRows = [];
                for(var i = 0 ; i < transferData.length; i++){
                    var row = transferData[i];
                    this.map[row._treeId] = row;
                }
                for(var j = 0 ; j < transferData.length; j++) {
                    var treeRow = transferData[j];
                    var pid = treeRow._treePid;
                    if(this.map[pid]) {
                        if(!this.map[pid]['children']) this.map[pid]['children'] = [];
                        this.map[pid]['children'].push(treeRow);
                        treeRow._p = true;
                    }
                }
                for(var k = 0 ; k < transferData.length; k++) {
                    var treeRow = transferData[k];
                    if(!treeRow._p) {
                        rootRows.push(treeRow);
                    }
                }
                transferData = rootRows;
            }
            this.data = transferData;
            this.handleShowPage(this.data)
            this.xmSelect = xmSelect.render({
                el: '#' + this.id,
                prop: {
                    name: 'label',
                    value: 'value',
                },
                radio : this.single,
                autoRow: true,
                clickClose: that.clickClose,
                filterable: true, //搜索模式
                size: 'small', // 尺寸
                paging: this.showPage,// 分页
                pageSize: 50,
                pageEmptyShow: false,// 无数据 不展示分页
                direction: 'auto',// 下拉方向
                model: {
                    label: {
                        block: {
                            template: function(item, sels){
                                return that.renderText(item._row, that.textField);
                            },
                        },
                    }
                },
                tree: {
                    //是否显示树状结构
                    show: that.showTree,
                    //是否展示三角图标
                    showFolderIcon: true,
                    //是否显示虚线
                    showLine: false,
                    //间距
                    indent: 20,
                    //默认展开节点的数组, 为 true 时, 展开所有节点
                    expandedKeys: true, 
                    //是否严格遵守父子模式
                    strict: that.strict,
                    //是否开启极简模式
                    simple: false,
                    //点击节点是否展开
                    clickExpand: true,
                    //点击节点是否选中
                    clickCheck: true,
                },
                template({ item, sels, name, value }){
                    return that.renderText(item._row, that.textField);
                },
                filterMethod: function(val, item, index, prop){
                    if(val == item.value){//把value相同的搜索出来
                        return true;
                    }
                    if(item.name.indexOf(val) != -1 || (item.label && item.label.indexOf(val) != -1)){//名称中包含的搜索出来
                        return true;
                    }
                    return false;//不知道的就不管了
                },
                data: transferData,
                theme: {
                  color: '#1c92e6',
                },
                on: function(data){
                    //arr:  当前多选已选中的数据
                    var arr = data.arr;
                    //change, 此次选择变化的数据,数组
                    var change = data.change;
                    //isAdd, 此次操作是新增还是删除
                    var isAdd = data.isAdd;
                    var valueArr = [];
                    for(var i = 0; i < arr.length; i++){
                        valueArr.push(arr[i].value);
                    }
                    that.$nextTick(()=> {
                        that.$emit('_modelEvent', valueArr.join(","));
                        that.$emit('selectChange', arr);
                    })
                },
            });
            if(this._model) {
                this.selectValue(this._model);
            }
        },
        refreshAsyncData(cb){
            this.isloaded = false;
            if(this._cacheCondition && Object.keys(this._cacheCondition).length > 0) {
                this.api.cache_get(
                            this.tableName,  this._cacheCondition.CACHE_KEY,  this._cacheCondition.CACHE_VALUE,
                            this.requestUniqueId
                    ).then(response => {
                    var results = response.result;
                    this.data = results;
                    this.load();
                    this.isloaded = true;
                    this.afterLoad();
                    if(cb) cb(results);
                });
            } else {
                this.api.queryList(
                            this.tableName,
                            {p2: this.condition,  p9: this.selectFields, p10: this.sort},
                            this.requestUniqueId
                    ).then(response => {
                    var results = response.result;
                    this.data = results;
                    this.load();
                    this.isloaded = true;
                    this.afterLoad();
                    if(cb) cb(results);
                });
            }
        },
        getSelectArr(ids){
            ids = ids + '';
            if(ids){
                return this.data.filter((item)=>{
                    return ids.split(',').indexOf(item.value + '') >= 0
                })
            }
        },
        afterLoad() {
           // 这时组件加载完了，但是可能外部已经修改了model的值，
           // 如果已经修改了，那么就不用执行initValue的逻辑了，因为这个时候initValue的值已经不算是最新的值了
            if(this._model) {
                this.selectValue(this._model);
                this.$emit('modelChange', this.getSelectArr(this._model));
            } else {
                if(this.initValue) {
                    // 修改v-model绑定的值
                    this.$nextTick(()=> {
                        // 注意$emit这里会触发下面watch监听的_model方法
                        // 是为了给v-model绑定的属性赋值
                        this.$emit('_modelEvent',this.initValue);
                        this.$emit('modelChange',this.getSelectArr(this.initValue));
                    });
                }
            }
            this.handleEnabled();
        },
        handleEnabled() {
            this.xmSelect.update({ disabled: !this.enabled });
        }
    },
    mounted(){
        this.showTree = this.idField && this.parentField;
        var element = this.el = $(this.$el);
        var id = this.id = 'A' + this.uuid();
        this.disabledId = this.id + "_disabled"
        element.attr('id', id);
        this.select = element.find(".multiselect");
        if(this.initData && this.initData.length > 0) {
            this.data = this.initData;
            this.load();
            this.isloaded = true;
            this.afterLoad();
        } else if(this.tableName) {
            if(!this.lazy) {
                this.condition = this.queryCondition;
                this._cacheCondition = this.cacheCondition;
                this.refreshAsyncData();
            } else {
                this.load();
            }
        } else {
            var children = this.select.children();
            if(children.length > 0) {
                for(var i = 0 ; i < children.length; i++) {
                    var child = $(children[i]);
                    var value = child.attr('value');
                    var text = child.text();
                    var obj = {};
                    obj[this.valueField] = value;
                    obj[this.textField] = text;
                    this.data.push(obj);
                }
                this.load();
                this.isloaded = true;
                this.afterLoad();
            }
        }
    },
    watch:{
        // 如果组件数据是异步加载的，那么可能会有时间差的问题，
        // 这个时候组件的model或者enabled等其他属性，可能在其他地方已经被修改了
        // 为了简单起见，我们使用为组件添加一个isLoaded属性，只有组件加载完毕了才会执行watch里面的逻辑，
        // 其他地方应该添加额外的判断这些watch可能没来得及执行的时候
        _model(value){
           if(this.isloaded) {
               this.selectValue(value);
           }
        },
        enabled() {
            if(this.isloaded) {
                this.handleEnabled();
            }

        }
    }
  }

</script>




// WEBPACK FOOTER //
// src/components/common/LayuiMultiSelect.vue